module.exports = __webpack_public_path__ + "static/media/photo317.d52653cc.jpg";